export const friedRiceRecipeContent = {
	"blocks": [{
			"key": "8b1se",
			"text": "Fried Rice Restaurant Style",
			"type": "header-one",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [{
					"offset": 0,
					"length": 10,
					"key": 0
				}
			],
			"data": {}
		}, {
			"key": "63pjm",
			"text": "A quick fried rice like you get at your favorite Chinese restaurant. A couple of eggs, baby carrots, peas and soy sauce is all you need.👍",
			"type": "blockquote",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [{
					"offset": 123,
					"length": 14,
					"key": 1
				}
			],
			"data": {}
		}, {
			"key": "fkd93",
			"text": "Ingredients",
			"type": "header-two",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [{
					"offset": 0,
					"length": 11,
					"key": 2
				}
			],
			"data": {}
		}, {
			"key": "59v0r",
			"text": "2 cups enriched white rice",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "16l17",
			"text": "4 cups water ",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "8opa4",
			"text": "⅔ cup chopped baby carrots 🥕",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "4dm01",
			"text": "½ cup frozen green peas ",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [{
					"offset": 0,
					"length": 23,
					"key": 3
				}
			],
			"data": {}
		}, {
			"key": "1qvbb",
			"text": "2 tablespoons vegetable oil ",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "57kfu",
			"text": "2 eggs ",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "1ta0",
			"text": "soy sauce to taste ",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "3pedd",
			"text": "2 tablespoons sesame oil, to taste",
			"type": "unordered-list-item",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "9s7t7",
			"text": "Directions",
			"type": "header-two",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "4ps02",
			"text": "Step 1 ",
			"type": "header-four",
			"depth": 0,
			"inlineStyleRanges": [{
					"offset": 0,
					"length": 7,
					"style": "BOLD"
				}
			],
			"entityRanges": [{
					"offset": 0,
					"length": 6,
					"key": 4
				}
			],
			"data": {}
		}, {
			"key": "a8fm7",
			"text": "In a saucepan, combine rice and water. Bring to a boil. Reduce heat, cover, and simmer for 20 minutes.",
			"type": "unstyled",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "7bi9d",
			"text": "Step 2",
			"type": "header-four",
			"depth": 0,
			"inlineStyleRanges": [{
					"offset": 0,
					"length": 6,
					"style": "BOLD"
				}
			],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "1l419",
			"text": "In a small saucepan, boil carrots in water about 3 to 5 minutes. Drop peas into boiling water, and drain.",
			"type": "unstyled",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "1aedr",
			"text": "Step 3",
			"type": "header-four",
			"depth": 0,
			"inlineStyleRanges": [{
					"offset": 0,
					"length": 6,
					"style": "BOLD"
				}
			],
			"entityRanges": [],
			"data": {}
		}, {
			"key": "ru3r",
			"text": "Heat wok over high heat. Pour in oil, then stir in carrots and peas; cook about 30 seconds. Crack in eggs, stirring quickly to scramble eggs with vegetables. Stir in cooked rice. Shake in soy sauce, and toss rice to coat. Drizzle with sesame oil, and toss again.",
			"type": "unstyled",
			"depth": 0,
			"inlineStyleRanges": [{
					"offset": 5,
					"length": 4,
					"style": "BOLD"
				}
			],
			"entityRanges": [],
			"data": {}
		}
	],
	"entityMap": {
		"0": {
			"type": "COMMENT",
			"mutability": "MUTABLE",
			"data": {
				"comment": "THIS IS A SAMPLE CONTENT.\nYou can save documents to the browser's local storage by typing in a name in the dropdown above and click the Create <doc name> option.",
				"color": "green"
			}
		},
		"1": {
			"type": "COMMENT",
			"mutability": "MUTABLE",
			"data": {
				"comment": "You can modify the color of this comment by clicking on this comment and setting a CSS color in the field above, e.g. \"darkblue\", \"#11F\" or \"#123456\"",
				"color": "red"
			}
		},
		"2": {
			"type": "COMMENT",
			"mutability": "MUTABLE",
			"data": {
				"comment": "To add a comment, highlight some text, then click the Comment button.",
				"color": "orange"
			}
		},
		"3": {
			"type": "COMMENT",
			"mutability": "MUTABLE",
			"data": {
				"comment": "I don't like green peas, so I will skip this.\nI will add spring onions instead.\nMaybe throw in some garlic too.",
				"color": "blue"
			}
		},
		"4": {
			"type": "COMMENT",
			"mutability": "MUTABLE",
			"data": {
				"comment": "Use rice cooker instead",
				"color": "magenta"
			}
		}
	}
}
